import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    Update,
    GetById,
    GetAllPoolName
} from "adminApi/PoolPackageApi/PoolPackage.js";
import { validateForm } from "utils/validation";
import { PoolPackageRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import fields from "../json/PoolPackageFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import EditPoolPackageForm from "./Components/EditPoolPackageForm";
import useFetchAllData from "Hooks/useFetchAllData";

const EditPoolPackage = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Initialize form values
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues, setErrors, handleFileChange } = useFormChange(initialValues, PoolPackageRules);

    // Fetch existing data by ID
    const { loading: loadingFetch } = useFetchFormDataById(id, formdata, GetById, setValues);

    const { data: PooNameOptions, loading: loadingPoolName } = useFetchAllData(GetAllPoolName);

    // Form submit hook
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            const formData = new FormData();
            Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
            return await Update({ id, data: formData });
        },
        (vals) => {
            const err = validateForm(vals, PoolPackageRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Pool Package updated successfully"
    );
    return (
        <>
            {(loadingFetch || loadingSubmit || loadingPoolName) && <Spinner isSpinner={true} />}
            <EditPoolPackageForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Edit Pool Package"
                handleFileChange={handleFileChange}
                imagePreview={values.pool_package_imagePreview || values.pool_package_image}
                PooNameOptions={PooNameOptions}
            />
        </>
    );
};

export default EditPoolPackage;
